function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import forEach from 'lodash/forEach';
import forOwn from 'lodash/forOwn';
import includes from 'lodash/includes';
import pick from 'lodash/pick';
import reject from 'lodash/reject';
import moment from 'moment/moment';
import * as actionTypes from './actionTypes';
import * as constants from './constants';
const initialState = {
    mode: constants.MODES[0],
    deviceMode: constants.DEVICES_MODES[0],
    calculationFormula: constants.CALCULATION_FORMULAS[0],
    aggregateBy: constants.AGGREGATE_BY[0],
    groupBy: constants.GROUP_BY[0],
    fromImports: null,
    fromImportsRange: null,
    selectedReading: null,
    isTrendChartLineEnabled: true,
    showCGMGoals: false,
    showTightRange: false,
    dashboardLayout: constants.DASHBOARD_LAYOUTS.bgm,
    resultsIsInProgress: true,
    reportsState: {},
    reportTypes: [],
    gestationalReportSettings: [
        {
            id: 'night_am',
            value: moment().hour(0).minute(0).format('HH:mm')
        },
        {
            id: 'breakfast',
            value: moment().hour(6).minute(0).format('HH:mm')
        },
        {
            id: 'lunch',
            value: moment().hour(12).minute(0).format('HH:mm')
        },
        {
            id: 'dinner',
            value: moment().hour(16).minute(0).format('HH:mm')
        },
        {
            id: 'night_pm',
            value: moment().hour(20).minute(0).format('HH:mm')
        }
    ],
    // only for newCDABloodGlucoseConcentrationPrint report
    // generated on b2b side. No need to fetch it on FE
    imbPatterns: []
};
function getFromImportsRange(fromImports, imports) {
    let maxResultDate = 0;
    let minResultDate = 0;
    forOwn(imports, (value)=>{
        forEach(value.documents, (document)=>{
            if (includes(fromImports, document.importDocumentId)) {
                if (maxResultDate < document.maxResultDate) {
                    maxResultDate = document.maxResultDate;
                }
                if (document.minResultDate && (!minResultDate || minResultDate > document.minResultDate)) {
                    minResultDate = document.minResultDate;
                }
            }
        });
    });
    return maxResultDate && minResultDate ? {
        maxResultDate,
        minResultDate
    } : null;
}
// eslint-disable-next-line default-param-last
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.SET_MODE:
            {
                const { mode } = action.payload;
                if (!includes(constants.MODES, mode)) {
                    return state;
                }
                const options = state.deviceMode === 'CGM' ? [] : pick(initialState, [
                    'calculationFormula',
                    'aggregateBy',
                    'groupBy'
                ]);
                if (mode === 'AGGREGATED') {
                    options.calculationFormula = constants.CALCULATION_FORMULAS[1];
                }
                return _object_spread_props(_object_spread({}, state, options), {
                    mode
                });
            }
        case actionTypes.SET_DEVICE_MODE:
            {
                const { deviceMode } = action.payload;
                let options;
                switch(deviceMode){
                    case 'CGM':
                        options = {
                            calculationFormula: constants.CALCULATION_FORMULAS_CGM[0],
                            groupBy: constants.GROUP_BY_CGM[0],
                            mode: constants.MODES[0],
                            dashboardLayout: constants.DASHBOARD_LAYOUTS.cgm
                        };
                        break;
                    case 'AGP':
                        options = {
                            calculationFormula: constants.CALCULATION_FORMULAS[0],
                            groupBy: constants.GROUP_BY_CGM[0],
                            mode: constants.MODES[2],
                            dashboardLayout: constants.DASHBOARD_LAYOUTS.agpBgm
                        };
                        break;
                    default:
                        options = {
                            calculationFormula: constants.CALCULATION_FORMULAS[0],
                            groupBy: constants.GROUP_BY[0],
                            mode: constants.MODES[0],
                            dashboardLayout: constants.DASHBOARD_LAYOUTS.bgm
                        };
                        break;
                }
                return _object_spread(_object_spread_props(_object_spread({}, state), {
                    deviceMode
                }), options);
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_CALCULATION_FORMULA:
            {
                const { calculationFormula } = action.payload;
                if (!includes(constants.CALCULATION_FORMULAS, calculationFormula) && !includes(constants.CALCULATION_FORMULAS_CGM, calculationFormula)) {
                    return state;
                }
                return _object_spread_props(_object_spread({}, state), {
                    calculationFormula
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_AGGREGATE_BY:
            {
                const { aggregateBy } = action.payload;
                if (!includes(constants.AGGREGATE_BY, aggregateBy)) {
                    return state;
                }
                return _object_spread_props(_object_spread({}, state), {
                    aggregateBy
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_GROUP_BY:
            {
                const { groupBy } = action.payload;
                if (!includes(constants.GROUP_BY, groupBy) && !includes(constants.GROUP_BY_CGM, groupBy)) {
                    return state;
                }
                return _object_spread_props(_object_spread({}, state), {
                    groupBy
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CHANGE_FROM_IMPORTS:
            {
                const { importDocumentId, imports } = action.payload;
                let fromImports;
                if (includes(state.fromImports, importDocumentId)) {
                    fromImports = reject(state.fromImports, (idi)=>idi === importDocumentId);
                    if (!fromImports.length) {
                        fromImports = null;
                    }
                } else {
                    fromImports = [
                        ...state.fromImports || [],
                        importDocumentId
                    ];
                }
                const fromImportsRange = getFromImportsRange(fromImports, imports);
                return _object_spread_props(_object_spread({}, state), {
                    fromImports,
                    fromImportsRange
                });
            }
        case actionTypes.CLEAR_FROM_IMPORTS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fromImports: null,
                    fromImportsRange: null
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_IS_TREND_CHART_LINE_ENABLED:
            {
                const { isTrendChartLineEnabled } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    isTrendChartLineEnabled
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_DASHBOARD_LAYOUT:
            {
                const { layout } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    dashboardLayout: layout
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_RESULTS_IN_PROGRESS:
            {
                const { isInProgress } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    resultsIsInProgress: isInProgress
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.DUMP_REPORTS_STATE:
            {
                const { reportsState } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    reportsState
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.STORE_SELECTED_REPORT_TYPES:
            {
                const { reportTypes } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    reportTypes
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_GESTATIONAL_REPORT_SETTINGS:
            {
                const { gestationalReportSettings } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    gestationalReportSettings
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_SELECTED_READING:
            {
                const { selectedReading } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    selectedReading
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
